module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#bundle",
      toString: function () {
        return this.url;
      }
    }